<div class="new-finding-trigger" [formGroup]="fg">
  <div class="trigger-settings-section">
    <div class="form-group">
      <div class="form-label">
        {{ 'playbooks.aiServices' | labelsProvider }}
      </div>
      <app-multi-select
        [options$]="aiServiceOptions$"
        [placeHolder]="'playbooks.selectAiServices' | labelsProvider"
        (optionOnSelection)="updateMultiSelectControl('aiServices', $event)"
        [selectedIds]="fg.controls['aiServices'].value || []"
      ></app-multi-select>
    </div>

    <div class="form-group">
      <div class="form-label">
        {{ 'playbooks.ruleIds' | labelsProvider }}
      </div>
      <app-multi-select
        [options$]="ruleOptions$"
        [placeHolder]="'playbooks.selectRules' | labelsProvider"
        (optionOnSelection)="updateMultiSelectControl('ruleIds', $event)"
        [selectedIds]="fg.controls['ruleIds'].value || []"
        [withSearch]="true"
        [withSelectAll]="true"
      ></app-multi-select>
    </div>

    <div class="form-group">
      <div class="form-label">
        {{ 'playbooks.ruleSeverity' | labelsProvider }}
      </div>
      <app-multi-select
        [options$]="severityOptions$"
        [placeHolder]="'playbooks.selectSeverity' | labelsProvider"
        (optionOnSelection)="updateMultiSelectControl('ruleSeverity', $event)"
        [selectedIds]="fg.controls['ruleSeverity'].value || []"
      ></app-multi-select>
    </div>
  </div>
</div>
